import { jsx as _jsx } from "react/jsx-runtime";
import Collapse from '@hellodarwin/core/lib/components/common/Collapse';
import { useTranslation } from 'react-i18next';
import getTestId from '../../../../../tests/utils/get-test-id';
import { AssistantMessageFormatter } from '../../../services/AssistantMessageFormatter';
import { CollapsibleSection, ToolArguments } from '../styles';
export const ToolArgumentsSection = ({ tool, expandedSections, setExpandedSections, }) => {
    const { t } = useTranslation();
    const args = AssistantMessageFormatter.formatToolArguments(tool);
    if (!args || typeof args !== 'object') {
        return null;
    }
    const argumentsItems = [
        {
            id: 'arguments',
            title: t('assistant.tool_arguments', 'Arguments'),
            children: (_jsx(ToolArguments, Object.assign({}, getTestId('assistant-tool-arguments'), { children: _jsx("pre", { children: JSON.stringify(args, null, 2) }) }))),
        },
    ];
    return (_jsx(CollapsibleSection, { children: _jsx(Collapse, { activeKey: expandedSections, onChange: (keys) => setExpandedSections(keys), ghost: true, items: argumentsItems }) }));
};
export default ToolArgumentsSection;
